module.exports = __webpack_public_path__ + "media/applicants/full-service-shopper-c413f4a1.webp";